import { render, staticRenderFns } from "./VendorProject.vue?vue&type=template&id=a98b970a&"
import script from "./VendorProject.vue?vue&type=script&lang=js&"
export * from "./VendorProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports